export const adrStatusOptions = [
  { label: 'Draft', value: 'draft' },
  { label: 'Proposed', value: 'proposed' },
  { label: 'Accepted', value: 'accepted' },
  { label: 'Rejected', value: 'rejected' },
  { label: 'Deprecated', value: 'deprecated' },
  { label: 'Superseded', value: 'superseded' },
] as const;

export type AdrStatus = (typeof adrStatusOptions)[number]['value'];
